/**
 * Product screenshots: which screens the Microsoft Store and the website show,
 * in what order, and what they say. Captured from the desktop app by
 * apps/desktop/scripts/capture-product-shots.mjs (which maps each slug to a
 * route) and rendered onto both surfaces by tools/product-shots.
 *
 * `slug` is the file name everywhere. `title` is the headline framed onto the
 * Store image and the website's tab label; `caption` describes what the shot
 * actually shows — the Store image description (at most 200 characters) and
 * the website's alt text.
 */
/** The ordered screenshot selection for every public surface. */
export const productShots = [
    {
        slug: 'dashboard',
        title: 'Operations overview',
        caption: 'Working capital, receivables, payables, POD pending, and the exceptions that need attention today.',
    },
    {
        slug: 'trips',
        title: 'Trips',
        caption: 'Trip status, routes, assigned vehicles and drivers in one working register.',
    },
    {
        slug: 'trip-details',
        title: 'Trip details',
        caption: 'Route, driver, vehicle, freight, payments, remaining balance, and delivery status together.',
    },
    {
        slug: 'action-center',
        title: 'Owner action centre',
        caption: 'Prioritised collections with overdue amounts, payment delays, and follow-up actions.',
    },
    {
        slug: 'vehicles',
        title: 'Vehicles',
        caption: 'Fleet records with documents, validity dates, loan terms, and vehicle activity.',
    },
    {
        slug: 'outstanding-analysis',
        title: 'Collections and risk',
        caption: 'Prioritise follow-ups with overdue exposure, payment delays, and customer risk in one view.',
    },
];
export const websiteScreenshotDescription = 'Explore real desktop workflows with fictional demo data. Select a screen, then open it full size for a closer look.';
//# sourceMappingURL=screenshots.js.map